class User {
  /*
   * Sets user in localStorage
   * @param {Object} user
   */
  set currentUser(user) {
    localStorage.setItem('user', JSON.stringify(user))
  }

  /*
   * Gets user from localStorage
   * @return {Object} user
   */
  get currentUser() {
    return JSON.parse(localStorage.getItem('user'))
  }

  /*
   * Sets user menu in localStorage
   * @param {Object} menu
   */
  set menu(menu) {
    localStorage.setItem('userMenu', JSON.stringify(menu))
  }

  /*
   * Gets user menu from localStorage
   * @return {Object} menu
   */
  get menu() {
    return JSON.parse(localStorage.getItem('userMenu'))
  }

  /*
   * Clears user and user menu from localStorage
   * @param {Object} menu
   */
  clearCache() {
    localStorage.removeItem('user')
    localStorage.removeItem('userMenu')
  }
}

export default User
